<template>
  <DialogConfirmation ref="dialogConfirmation"/>
  <div class="row">
    <div class="col">
      <DataTable
          class="p-datatable-sm"
          :value="regroupements"
          :resizableColumns="true"
          columnResizeMode="fit"
          :reorderableColumns="true"
          dataKey="cle"
          :paginator="true"
          :rows="10"
          sort-field="cle"
          :sortOrder="-1"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 30, 100]"
          currentPageReportTemplate="Afficher {first} de {last} sur {totalRecords} regroupements"
      >
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <Column
            field="cle"
            header="Clé"
            :sortable="true"
        ></Column>
        <Column field="description" header="Description" :sortable="true">
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <InputText v-model="data[field]"/>
              </div>
            </div>
          </template>
        </Column>
        <Column
            field="secteurAfficher"
            header="Secteur"
            :sortable="true"
        ></Column>
        <Column field="quota" header="Quota" :sortable="true">
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <InputText v-model="data[field]"/>
              </div>
            </div>
          </template>
        </Column>
        <Column field="quotaMin" header="Quota minimum" :sortable="true">
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <InputText v-model="data[field]"/>
              </div>
            </div>
          </template>
        </Column>
        <Column headerStyle="width: 8rem" :exportable="false">
          <template #body="slotProps">
            <div class="row">
              <div class="col">
                <Button
                    icon="pi pi-save"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="sauvegarder(slotProps.data)"
                />
              </div>
              <div class="col">
                <Button
                    icon="pi pi-trash"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="confirmerSuppression(slotProps.data)"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import axios from 'axios';
import DialogConfirmation from '../../../Commun/DialogConfirmation.vue';

export default {
  props: ['regroupements', 'isRechercheDataLoading'],
  emits: ['removeRegroupementFromList'],
  components: {
    DialogConfirmation
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      regroupementToDelete: null,
    }
  },
  methods: {
    confirmerSuppression(data) {
      this.regroupementToDelete = data.cle
      this.$confirm.require({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: "Voulez-vous supprimer le regroupement?",
        accept: this.supprimer,
        reject: () => {},
      })
    },
    supprimer() {
      this.$store.dispatch('pilotage/supprimerRegroupementAction', {cle: this.regroupementToDelete}).then(() => {
        this.$toast.add({
          severity:'success',
          summary: 'Suppression Regroupement',
          detail:"La suppression a été effectuée",
          life: 6000
        });
        this.$emit("removeRegroupementFromList", this.regroupementToDelete);
      });
    },
    sauvegarder(data) {
      this.$store.dispatch('pilotage/modifierRegroupementAction', {regroupement: data}).then(() => {
        this.$toast.add({
          severity:'success',
          summary: 'Modifier Regroupement',
          detail:"La modification a été effectué",
          life: 6000
        });
      });
    }
  }
}
</script>
